module.exports = __webpack_public_path__ + "static/img/3.5040ba4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3.jpg
// module id = 323
// module chunks = 0